import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFolderArrow = () => {
  return (
    <g>
      <path d="m15.828 9.7124a.75.75 0 0 0 -.647-.3706h-2.102v-2.1343a.75.75 0 0 0 -.75-.75h-5.8447v-.9253a.75.75 0 0 0 -.75-.75h-4.9155a.75.75 0 0 0 -.75.75v9.6631l.0008.0041c0 .009.0049.017.0053.026a.733.733 0 0 0 .0865.3117c.0062.0119.0036.026.01.0377.0111.0188.0324.0269.0449.0445a.7311.7311 0 0 0 .1841.1821.7088.7088 0 0 0 .08.054.7318.7318 0 0 0 .3378.09h11.51a.7506.7506 0 0 0 .6548-.3843l2.852-5.1035a.749.749 0 0 0 -.007-.7452zm-10.8437-3.4302v.9253a.75.75 0 0 0 .75.75h5.8447v1.3843h-7.9077a.7506.7506 0 0 0 -.6548.3843l-1.4477 2.59v-6.0339zm6.9048 8.1631h-9.792l2.0142-3.6035h9.7915z" />
      <path d="m11.8339 5.7422a.7029.7029 0 0 0 .99 0l2.0991-2.0991a.7.7 0 0 0 -.99-.99l-.9038.9041v-2.8023a.7.7 0 0 0 -1.4 0v2.802l-.9038-.9041a.7.7 0 0 0 -.99.99z" />
    </g>
  );
};

export default withIcon(IconFolderArrow);
